import * as React from "react";
import { useTranslation } from "react-i18next";
import PrwcTextButton from "../../../widgets/custom/buttons/PrwcTextButton";

const VerticalInputTextArrayTemplate = (props: any) => {
  const { t } = useTranslation();
  // console.log("vertical array ---");
  // console.log(props);
  return (
    <div>
      {props.items.map((element: any) => (
        <div className={`flex items-center ${element.index === 0 ? "mt-0 mb-2": "my-2"}`} key={element.index}>
          <div className="w-full"> {element.children}</div>
          <div>
            {element.hasRemove && props.items.length > 1 && (
              <li
                className="ml-2 cursor-pointer pi pi-minus-circle"
                onClick={element.onDropIndexClick(element.index)}
              ></li>
            )}
          </div>
        </div>
      ))}
      {props.canAdd && (
        <div className="flex items-end justify-end w-full">
          <PrwcTextButton
            icon="pi pi-plus-circle"
            className="p-button-text p-button-sm"
            labelKey={t("generic.action.add")}
            onClick={props.onAddClick}
          ></PrwcTextButton>
        </div>
      )}
    </div>
  );
};

export default VerticalInputTextArrayTemplate;
